import { LifetimeTableRow } from "@/providers/LifetimeTable/LifetimeTableTypes";

export const getHeaders = (rows: LifetimeTableRow[]) => {
  const headers: string[] = [];

  rows.forEach((row) => {
    Object.entries(row.materialLifeTime).forEach(([key, _value]) => {
      headers.push(key);
    });
  });

  headers.sort((a, b) => (a > b ? 1 : -1));

  const set = new Set(headers);

  return Array.from(set);
};

export const lifetimeTableFilter = (
  rows: LifetimeTableRow[],
  selectedParentNames: string[],
  structure: string
): {
  rows: LifetimeTableRow[];
  parentsWithId: string[];
  materialGroups: string[];
} => {
  //If no filter is selected (Default)
  if (selectedParentNames[0] === "All materials selected" && structure === "All structures selected")
    return {
      rows,
      parentsWithId: getParentWithParentId(rows),
      materialGroups: materialGroupings,
    };
  // if a material is selected and structure isn't
  else if (structure === "All structures selected") {
    const filteredRows = rows.reduce((acc, row) => {
      if (Object.keys(row.materialLifeTime).some((lifeTime) => selectedParentNames.includes(lifeTime))) return [...acc, row];
      return acc;
    }, [] as LifetimeTableRow[]);
    return {
      rows: filteredRows,
      parentsWithId: getParentWithParentId(filteredRows),
      materialGroups: materialGroupings,
    };
  }
  //if a structure is selected and a material isnt
  else if (selectedParentNames[0] === "All materials selected") {
    const filteredRows = rows.reduce((acc, row) => {
      if (row.parentName === structure) return [...acc, row];
      return acc;
    }, [] as LifetimeTableRow[]);

    return {
      rows: filteredRows,
      parentsWithId: getParentWithParentId(rows),
      materialGroups: getMaterialGroupingsFromRows(filteredRows),
    };
    //if both material and structure is filtered on
  } else {
    const filteredRows = rows.reduce((acc, row) => {
      if (
        Object.keys(row.materialLifeTime).some((lifeTime) => selectedParentNames.includes(lifeTime)) &&
        row.parentName === structure
      )
        return [...acc, row];
      return acc;
    }, [] as LifetimeTableRow[]);
    return {
      rows: filteredRows,
      parentsWithId: getParentWithParentId(filteredRows),
      materialGroups: getMaterialGroupingsFromRows(filteredRows),
    };
  }
};

const getMaterialGroupingsFromRows = (rows: LifetimeTableRow[]) => {
  const matGroupings = materialGroupings.map((materialGroup) => {
    const usedMaterials = Array.from(new Set(rows.map((row) => Object.keys(row.materialLifeTime)).flatMap((mat) => mat)));
    return usedMaterials.some((usedMat) => usedMat[0] === materialGroup[0]) ? materialGroup : "";
  });

  return ["All materials selected", ...Array.from(new Set(matGroupings)).filter((group) => group.length > 0)];
};

export const getParents = (rows: LifetimeTableRow[]) => {
  const parents: string[] = [];

  rows.forEach((row) => {
    parents.push(row.parentName);
  });

  parents.sort((a, b) => (a > b ? 1 : -1));

  const set = new Set(parents);

  return Array.from(set);
};

export const getSuperParents = (rows: LifetimeTableRow[]) => {
  const parents: string[] = [];

  rows.forEach((row) => {
    parents.push(row.superParentName);
  });

  parents.sort((a, b) => (a > b ? 1 : -1));

  const set = new Set(parents);

  return Array.from(set);
};

export const getParentWithParentId = (rows: LifetimeTableRow[]) => {
  const parentsWithId: string[] = rows.reduce((acc, row) => {
    return [...acc, row.parentId + " - " + row.parentName];
  }, [] as string[]);

  parentsWithId.sort((a, b) => (a > b ? 1 : -1));

  return ["All structures selected", ...Array.from(new Set(parentsWithId))];
};

export const materialGroupings: string[] = [
  "All materials selected",
  "e - Natursten",
  "f - Afbundne mørtler",
  "g - Ler (tørret, brændt)",
  "h - Metal",
  "i - Træ",
  "j - Vegatabilske og animalske materialer",
  "m - Uorganiske fibre",
  "n - Asfalt (bitumen), gummi, plast etc",
  "o - Glas",
  "p - Tilslags- og fyldmateriale",
  "v - Malervarer",
];

export const findMaterials = (material: string, rows: LifetimeTableRow[]) => {
  const rowsWithMaterials = rows
    .map((row) => {
      const materials = Object.keys(row.materialLifeTime);
      return materials.filter((mat) => mat[0] === material[0]);
    })
    .flatMap((mat) => mat);
  return Array.from(new Set(rowsWithMaterials));
};
